module.exports = function(app) {
    var attachFileAlertModal = require("chmhom/modals/attachFileAlertModal");
    app.controller("pages.spending.newReceipt", ["$scope", "session","services", "storage","coremetrics","spendingResourceServices","$cookies","invisibleForm",'educationalMaterialService', '$window','$timeout','virusScanService','modal','$filter',
        function( $scope, session, services, storage, coremetrics, spendingResourceServices, $cookies, invisibleForm, educationalMaterialService, $window, $timeout,virusScanService,modal,$filter) {

            $scope.viewState = 'loading';

            $scope.backAction = function() {
                $window.history.back();
            };
            $scope.cancel = function() {
                $window.location = '/member/spending/receipts';
            };

            $scope.resetForm = function() {
                document.getElementById('newReceipt').reset();
            };

            $scope.attachedFiles=[];
            var _attachedFileCounter = 0;

            $scope.viewState="";
            $scope.deleteChar = String.fromCharCode(215);
            $scope.firstMoxieLoad = true;


            $scope.fileStatusIcon = "";
            $scope.hasFileData = false; //hide example table
            $scope.pluginState = false; // disable button until plugin has initialized

            $scope.showPicker = true;
            $scope.fileCount = 0;
            $scope.newFilePayload = false;
            $scope.newSubmitState = false;
            $scope.reply=false;
            $scope.selectedTopic="";
            var fileArray = [];
            var downloadAttachmentUrl ="/rbsmbl/x-services/download/securemessage/attachment";
            var _attachedBytes = 0;
            $scope.showAddFileButton = true;
            $scope.deleteChar = String.fromCharCode(215);
            $scope.selectedCategory="";
            $scope.dateValStr =""; //$filter('date')(new Date(), 'MM/dd/yyyy');
            $scope.dateVal = new Date();



           /* $scope.dateVal = new Date();
            $scope.dateVal.setMonth(Number(dateVal.substr(0,2)) - 1);
            $scope.dateVal.setDate(dateVal.substr(3,2));
            $scope.dateVal.setFullYear(dateVal.substr(6));
            $scope.dateVal.setHours(0);
            $scope.dateVal.setMinutes(0);
            $scope.dateVal.setSeconds(0);
            $scope.dateVal.setMilliseconds(0);*/

            $scope.showCalendar =false;

            $scope.endDate = $filter('date')(new Date(), 'MM/dd/yyyy');
            $scope.participantCode = "";
            $scope.groupCode = "";
            $scope.payMode = "";
            $scope.receiptAmount="";
            $scope.noteTextArea="";
            $scope.serviceProvider="";




            var  buildNewReceiptView = function(participantCode, groupCode) {
                var getParams = {};
                getParams.participantCode = participantCode;
                getParams.groupCode = groupCode;
                getParams.clientName = "Mobile";
                services.rbsmbl.receiptCategories().fetch(getParams).then(function(response){
                    var claimsSetupData = response.payload.repSetupClaimData;
                    $scope.participantCode = getParams.participantCode;
                    $scope.groupCode = getParams.groupCode;
                    $scope.payMode = claimsSetupData.payMode;

                    var claimsArray = claimsSetupData.clmCategoryClmType.category;
                    setCategories(claimsArray);
                },function(error){
                    console.log("error while fetching categories");
                    if($window.location.host.indexOf("tenv")>-1 || $window.location.host.indexOf("denv")>-1) {
                        var response = '{"repSetupClaimReply":{"baseMessage":{"uuid":"64BA1E88CEE8440D99181AA7786B6BB0","returnCode":200,"returnCodeDescription":"OK","statusMsgs":{"messages":[{"level":0,"values":[]}]}},"payload":{"repSetupClaimData":{"clmCategoryClmType":{"category":[{"claimType":[{"type":[{"name":"WITHDRAWAL","label":"WITHDRAWAL"}],"typeListCount":"1"}],"name":"Cash","label":"Cash"},{"claimType":[{"type":[{"name":"COINSURANCE","label":"COINSURANCE","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"CONVERSION","label":"CONVERSION","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"COPAY","label":"COPAY","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"DEDUCTIBLE","label":"DEDUCTIBLE","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"EQUIPMENT","label":"EQUIPMENT","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"EXAMINATION","label":"EXAMINATION","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"ORTHODONTIA","label":"ORTHODONTIA","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"OVER THE COUNTER MEDICATION","label":"OVER THE COUNTER MEDICATION","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"PHARMACY PRESCRIPTION","label":"PHARMACY PRESCRIPTION","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"RELATED TRAVEL","label":"RELATED TRAVEL","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"TREATMENT","label":"TREATMENT","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""}],"typeListCount":"11"}],"name":"Dental","label":"Dental","receiptRequired":"","priorYearActivePlan":"No","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"claimType":[{"type":[{"name":"AMBULANCE","label":"AMBULANCE","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"COINSURANCE","label":"COINSURANCE","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"CONVERSION","label":"CONVERSION","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"COPAY","label":"COPAY","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"DEDUCTIBLE","label":"DEDUCTIBLE","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"DOCTOR","label":"DOCTOR","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"EQUIPMENT","label":"EQUIPMENT","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"EXAMINATION","label":"EXAMINATION","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"HOSPITAL","label":"HOSPITAL","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"LABORATORY","label":"LABORATORY","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"PHARMACY PRESCRIPTION","label":"PHARMACY PRESCRIPTION","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"PREMIUMS","label":"PREMIUMS","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"RELATED TRAVEL","label":"RELATED TRAVEL","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"THERAPY","label":"THERAPY","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"TREATMENT","label":"TREATMENT","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""}],"typeListCount":"15"}],"name":"Medical","label":"Medical","receiptRequired":"","priorYearActivePlan":"No","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"claimType":[{"type":[{"name":"OVER THE COUNTER MEDICATION","label":"OVER THE COUNTER MEDICATION","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""}],"typeListCount":"1"}],"name":"Medical-OTC","label":"Medical-OTC","receiptRequired":"","priorYearActivePlan":"No","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"claimType":[{"type":[{"name":"IMMUNIZATION","label":"IMMUNIZATION","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"PHYSICALS","label":"PHYSICALS","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"SCREENING","label":"SCREENING","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"SMOKING CESSATION","label":"SMOKING CESSATION","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"WEIGHT LOSS","label":"WEIGHT LOSS","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""}],"typeListCount":"5"}],"name":"Medical-Preventative","label":"Medical-Preventative","receiptRequired":"","priorYearActivePlan":"No","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"claimType":[{"type":[{"name":"COINSURANCE","label":"COINSURANCE","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"CONVERSION","label":"CONVERSION","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"COPAY","label":"COPAY","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"DEDUCTIBLE","label":"DEDUCTIBLE","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"EQUIPMENT","label":"EQUIPMENT","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"EXAMINATION","label":"EXAMINATION","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"OVER THE COUNTER MEDICATION","label":"OVER THE COUNTER MEDICATION","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"PHARMACY PRESCRIPTION","label":"PHARMACY PRESCRIPTION","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"RELATED TRAVEL","label":"RELATED TRAVEL","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""},{"name":"TREATMENT","label":"TREATMENT","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""}],"typeListCount":"10"}],"name":"Vision","label":"Vision","receiptRequired":"","priorYearActivePlan":"No","dispSeq":"","value1":"","value2":"","value3":"","value4":"","value5":""}],"categoryListCount":"5"},"payMode":"Self"}}}}';
                        response = JSON.parse(response);
                        var claimsSetupData = response.repSetupClaimReply.payload.repSetupClaimData;
                        $scope.participantCode = getParams.participantCode;
                        $scope.groupCode = getParams.groupCode;
                        $scope.payMode = claimsSetupData.payMode;

                        var claimsArray = claimsSetupData.clmCategoryClmType.category;
                        setCategories(claimsArray);
                    }

                });

            };
            var setCategories =function(categoryList){
                var categoriesList=[];
                var options = {};
                categoryList.forEach(function(category){
                    if (category.label != "Cash"){
                        options = {
                            "label": category.label,
                            "value": category.name
                        };
                        categoriesList.push(options);
                    }                });
                $scope.categoriesList = categoriesList;
                $scope.selectedCategory = categoriesList[0].value;
            };
            var items = storage.get("selectedClient");
            buildNewReceiptView(items.participantCode,items.groupCode);

            //function to initialize moxie plugin for file upload
            var addFile = function () {
                // designate a DOM element as the file picker button
                var fileInput = new mOxie.FileInput({
                    browse_button: 'contactUs-attachFile'
                });

                fileInput.onmousedown = function() {
                    $scope.invalidFileType=false;
                    $scope.fileSizeOverLimit=false;
                    $scope.fileVirusScanError=false;
                    $scope.fileScanTimeoutLI=false;

                };


                // fires when user closes file dialog after a file is selected
                fileInput.onchange = function (evt) {
                    var fileFilter = "application/pdf,image/jpeg,image/tif,image/x-tif,image/tiff,image/x-tiff,application/tif,application/x-tif,application/tiff,application/x-tiff,image/ibm_ondemand";
                    if (evt.target.files && $scope.attachedFiles.length < 1) {

                        // files is a FileList of File objects.
                        for (var i = 0, f; f = evt.target.files[i]; i++) {

                            // check mime type and handle error
                            if (!(f.type.match(fileFilter.replace(/,/g, "|")))) {
                                applyErrorMsg("invalidFileType",true);
                                return;
                            }

                            // If file is greater than 5MB
                            if (f.size > (Math.pow(1024, 2) * 5)) {
                                applyErrorMsg( "fileSizeOverLimit",true);
                                return;
                            }


                            var reader = new mOxie.FileReader();

                            reader.onloadstart = (function (theFile) {

                                return function (e) {
                                    // Increment file counter

                                    _attachedFileCounter++;


                                    var attachment = {
                                        "attachmentId": _attachedFileCounter,
                                        "fileUploadStatus": "pending",
                                        "fileName": theFile.name,
                                        "fileSize": theFile.size

                                    };
                                    $scope.attachedFiles.push(attachment);
                                    $scope.confirmDeleteAttachment = function (attachmentName) {

                                        var modalButtons=[
                                            {
                                                buttonLabel:"CANCEL",
                                                buttonClass:"primary",
                                                buttonAction:function(){$scope.closeModal();}
                                            },
                                            {
                                                buttonLabel:"OK",
                                                buttonClass:"primary",
                                                buttonAction:function(){$scope.closeModal();deleteAttachment(attachmentName);}
                                            }
                                        ];

                                        openAttachmentAlertModal('Confirm attachment removal','Are you  sure you want to delete ' + attachmentName.toLowerCase() + '?',modalButtons);

                                    }




                                };
                            })(f);

                            // Closure to capture the file information.
                            reader.onload = (function (theFile) {

                                return function (e) {

                                    $scope.fileBinary = e.target.result;

                                    var binaryOnly = $scope.fileBinary.split(',')[1];

                                    // virus scan
                                    virusScanService.getData(binaryOnly).then(
                                        function(response) {
                                            var parsedResult = response.data;
                                            if (parsedResult && parsedResult.baseMessage && parsedResult.baseMessage.returnCodeDescription === "Virus detected") {
                                                _attachedFileCounter--;
                                                console.log("virus detected");
                                                $scope.fileVirusScanError=true;
                                                applyErrorMsg("fileVirusScanError",true);
                                                $scope.attachedFiles[0].fileUploadStatus="failed";
                                            }else{
                                                console.log("no virus detected");
                                                applyErrorMsg("fileVirusScanError",false);
                                                var  fileDetails = {
                                                    "fileData": binaryOnly,
                                                    "strippedFileName": theFile.name.toLowerCase().replace(/[\. ,:-]+/g, "-"),
                                                    "fileUploadStatus":"success",
                                                    "fileType":theFile.type
                                                };
                                                angular.extend($scope.attachedFiles[0],fileDetails);


                                            }
                                        }
                                    ),function(error){
                                        applyErrorMsg("fileScanTimeoutLI",true);
                                    };


                                };
                            })(f);

                            // Read in the image file as a data URL.
                            reader.readAsDataURL(f);
                        }
                    }


                };
                // initialize plugin
                fileInput.init();
            };

            $scope.downloadAttachment = function(attachmentId) {
                var downloadAttachment = "";
                if (attachmentId){
                    $scope.attachedFiles.forEach(function (attachment) {
                        if (attachment.attachmentId === attachmentId) {
                            downloadAttachment = attachment;
                        }
                    });
                }
                if(downloadAttachment){
                 /*   window.URL = window.URL || window.webkitURL;
                    var uri = null;

                    window.open(downloadAttachment.scannedFileBinary);
                    uri = window.URL.createObjectURL(base64toBlob.base64toBlob(downloadAttachment.scannedFileBinary, downloadAttachment.fileType));
                    console.log("file uri", uri);*/

                    var byteCharacters = atob(downloadAttachment.fileData);
                    var byteNumbers = new Array(byteCharacters.length);
                    for(var i=0;i<byteCharacters.length;i++){
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    var byteArray = new Uint8Array(byteNumbers);
                    var blob = new Blob([byteArray], {type:  downloadAttachment.fileType});



                    var blobUrl = URL.createObjectURL(blob);
                    window.open(blobUrl);

                }
            }

            var deleteAttachment=function(attachmentName){
                if (attachmentName) {
                    var index = -1;
                    var fileSize = 0;
                    for (var i = 0; i < $scope.attachedFiles.length; i++) {
                        if (attachmentName === $scope.attachedFiles[i].fileName) {
                            fileSize = $scope.attachedFiles[i].fileSize;
                            index = i;
                            break;
                        }
                    }

                    if (index > -1) {
                        _attachedBytes = _attachedBytes - fileSize;
                        $scope.attachedFiles.splice(index, 1);
                    }
                }
            };

            var applyErrorMsg=function(errorMsgVar,status){
                $scope[errorMsgVar] = status;
               // $scope.$apply();
            };

            var openAttachmentAlertModal =function(title,description,buttons){
                $scope.modalTitle = title;
                $scope.modalDescription = description;
                if(buttons){
                    $scope.modalButtons =buttons;
                }else {
                    $scope.modalButtons = [
                        {
                            buttonLabel: "OK",
                            buttonClass: "primary",
                            buttonAction: function () {
                                $scope.closeModal()
                            }
                        }
                    ];
                }
                modal.open({
                    template: require('chmhom/modals/attachFileAlertModal.html'),
                    controller: attachFileAlertModal,
                    scope: $scope
                });
            };

            $scope.closeModal = function(){
                modal.close();
            };

            $timeout(function () {
                if ($scope.firstMoxieLoad) {
                    addFile();
                    $scope.firstMoxieLoad = false;
                }
            }, 1000);

            var getReceiptID=function(){
                return "";
            };

            $scope.saveReceipt=function(){
                var payload = {
                    "participantCode": $scope.participantCode,
                    "groupCode": $scope.groupCode,
                    "clientName": "Mobile",
                    "userType": "EE",
                    "ShoeboxItemRequest": {
                        "category": $scope.selectedCategory,
                        "amount": $scope.receiptAmount + "",
                        "ID": getReceiptID(),
                        "paymentMode": $scope.payMode,
                        "note": $scope.noteTextArea,
                        "provider": $scope.serviceProvider,
                        "serviceDate": $scope.dateVal,
                        "patientName": "",
                        "shoeboxImage": {
                            "name": $scope.attachedFiles[0].fileName,
                            "size": $scope.attachedFiles[0].fileSize,
                            "imageData": $scope.attachedFiles[0].fileData
                        }
                    }
                };

                services.rbsmbl.getSaveShoeboxItem().fetch(payload).then(function(response){
                    console.log(response);
                },function(error){

                });
            }


        }])
};